(function () {
    'use strict';

    angular
        .module('cacmControlModule')
        .directive('cacmControl', directive);

    directive.$inject = ['boxTmplScope', 'boxTmplHtml', 'boxTmplLinkFn', 'cacmService'];

    function directive(boxTmplScope, boxTmplHtml, boxTmplLinkFn, cacmService) {

        var directiveScope = _.clone(boxTmplScope);

        return {
            scope: directiveScope,
            template: boxTmplHtml,
            controller: ['$rootScope', '$scope', '$controller',
                function ($rootScope,   $scope,   $controller) {

                    // Box Template
                    $scope.baseTemplatePath = '/app/shared/cacm/control/cacmControl.[Template].tpl.html';
                    $controller('BoxTmplController', { $scope: $scope });
                    
                    // Highlighting
                    function setupHighlighting(result) {
                        var highlighting = [];
                        for (var p in result) {
                            if (result.hasOwnProperty(p) && result[p] instanceof Array) {
                                if (p === 'Description') {
                                    $scope.boxModel.Description = result[p][0];
                                } else {
                                    Array.prototype.push.apply(highlighting, result[p]);
                                }
                            }
                        }
                        return highlighting.length > 0 ? highlighting : null;
                    }

                    if ($scope.boxModel && $scope.boxModel.highlighting) {
                        $scope.boxModel.highlighting = setupHighlighting($scope.boxModel.highlighting);
                    }

                    $scope.goToControl = function(control) {
                        $scope.clickOnBox({ control: control });
                    };

                    // Convert hexadecimal color code to rgba with specific opacity
                    $scope.convertHex = function (hex, opacity) {
                        var r, g, b;
                        hex = hex.replace('#', '');
                        r   = parseInt(hex.substring(0, 2), 16);
                        g   = parseInt(hex.substring(2, 4), 16);
                        b   = parseInt(hex.substring(4, 6), 16);

                        return 'rgba(' + r + ',' + g + ',' + b + ',' + (opacity ? opacity : .2) + ')';
                    };
                }],
            link: function (scope, elem, attrs) {
                boxTmplLinkFn(scope, elem, attrs);
            }
        }
    }
})();